import {
  FETCH_DRIVERS_EARNING,
  FETCH_DRIVERS__EARNING_SUCCESS,
  FETCH_DRIVERS__EARNING_FAILED,
} from "../store/types";
import {
  cloud_function_server_url,
} from '../../config';

const END_POINT = `${cloud_function_server_url}/booking`;


export const fetchDriverEarnings = (uid,role) => (dispatch) => (firebase) => {

  const {
    bookingListRef
  } = firebase;

  dispatch({
    type: FETCH_DRIVERS_EARNING,
    payload: null
  });

  fetch(`${END_POINT}/fetch-bookings`, {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json',
    },
})
    .then(async (res) => {
        const response = await res.json();
        const mainArr = response?.data

        var monthsName = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        var renderobj = {};
        mainArr.map(item => {
          if ((item.status === 'PAID' || item.status === 'COMPLETE') && item.driver_share !== undefined) {
            let bdt = new Date(item.tripdate);
            let uniqueKey = bdt.getFullYear() + '_' + bdt.getMonth() + '_' + item.driver;
            if (renderobj[uniqueKey] && renderobj[uniqueKey].driverShare > 0) {
              renderobj[uniqueKey].driverShare = renderobj[uniqueKey].driverShare + item.driver_share;
            } else {
              renderobj[uniqueKey] = {};
              renderobj[uniqueKey]['dated'] = item.tripdate;
              renderobj[uniqueKey]['year'] = bdt.getFullYear();
              renderobj[uniqueKey]['month'] = bdt.getMonth();
              renderobj[uniqueKey]['monthsName'] = monthsName[bdt.getMonth()];
              renderobj[uniqueKey]['driverName'] = item.driver_name;
              renderobj[uniqueKey]['driverShare'] = item.driver_share;
              renderobj[uniqueKey]['driverVehicleNo'] = item.vehicle_number;
              renderobj[uniqueKey]['driverUId'] = item.driver;
              renderobj[uniqueKey]['uniqueKey'] = uniqueKey;
            }
          }
          return null;
        });
        if (renderobj) {
          const arr = Object.keys(renderobj).map(i => {
            renderobj[i].driverShare = parseFloat(renderobj[i].driverShare).toFixed(2)
            return renderobj[i]
          })
          dispatch({
            type: FETCH_DRIVERS__EARNING_SUCCESS,
            payload: arr
          });
        }

    }).catch(error => {
        console.log("FETCH_BOOKING__DISCOUNT_FAILED", error)
        dispatch({
          type: FETCH_DRIVERS__EARNING_FAILED,
          payload: "No data available."
        });
    });
};

